import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { IonList, IonItem, IonIcon, IonLabel } from '@ionic/react';
import { Constants } from '../../defines/Constants';
import { chevronBack } from 'ionicons/icons';
import axios from 'axios';
import Loading from '../Loading';
import './Links.css';

const Links = () => {
    const [loading, setLoading] = useState(false);
    const [links, setLinks] = useState([]);
    const linksApi = Constants.api.links;
    useEffect(() => {
        const getBlog = async () => {
            setLoading(true);
            try {
                const results = await axios.get(linksApi);
                if (results.status === 200) {
                    setLinks(results.data.link_items);
                    setLoading(false);
                }
            } catch (error: any) {
                console.log(error);
            }
        }
        getBlog();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const history = useHistory();
    const onReadMoreClick = (pageId: any, url: any) => {
        if (pageId !== null) {
            history.push({
                pathname: '/page',
                state: pageId
            });
        } else if (url !== null) {
            window.open(url, "_blank");
        }
    }
    const linksEl = links.map((item: any, index: number) =>
        <IonItem className="links-box-item" key={"index" + index} onClick={() => onReadMoreClick(item.page_id, item.url)}>
            <IonIcon icon={chevronBack} className="links-arrow" />
            <IonIcon icon={Constants.uploads + 'menues_app/' + item.icon} className="links-box-icon" />
            <IonLabel>{item.title}</IonLabel>
        </IonItem>
    )
    return (
        <div className="links-box-container">
            <IonList>
                {!loading ?
                    linksEl
                    :
                    <Loading />
                }
            </IonList>
        </div>
    );
};
export default Links;